export default __webpack_public_path__ + "static/media/Text_FillingColor.b78c9729.svg";